import { BODY_COLOR_OPACITY } from '@/components/DesignSystem/ModernTheme/utils/common';
import styled from 'styled-components';

export const ModernMiddleBodyLayout1Wrapper = styled.div`
  width: 100%;

  &.map1_container {
    display: flex;
    flex-direction: column;

    &.map1_container > .top_section {
      display: flex;
      flex: 0;
    }
    &.map1_container > .bottom_section {
      flex: 1;
    }
    &.map1_container > .top_section > .top_section_left {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      flex: 1;
    }
    &.map1_container > .top_section > .top_section_left h1 {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      width: 100%;
      margin: 0;
      color: ${(props) => props?.themeStyle?.heading?.color};
      font-family: ${(props) => props?.themeStyle?.heading?.fontFamily || 'Arial'};
      text-align: ${(props) => props?.themeStyle?.heading?.textAlign || 'left'};
      overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */
      overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */
    }
    &.map1_container > .top_section > .top_section_left p {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      width: 100%;
      font-style: normal;
      margin: 0;
      color: ${(props) => props?.themeStyle?.body?.color};
      text-align: ${(props) => props?.themeStyle?.body?.textAlign || 'left'};
      font-family: ${(props) => props?.themeStyle?.body?.fontFamily || 'Arial'};
      opacity: ${BODY_COLOR_OPACITY};
      overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */
      overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */
    }
    &.map1_container > .top_section > .top_section_right {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      align-self: center;
    }
    @media screen and (min-width: 768px) {
      padding: 4rem;
      gap: 2rem;
      &.map1_container > .top_section {
        gap: 4rem;
        flex-direction: row;
      }
      &.map1_container > .top_section > .top_section_left h1 {
        font-size: ${(props) => props?.textStyles?.heading?.fontSize || '3.25rem'};
        font-weight: ${(props) => props?.textStyles?.heading?.fontWeight || '500'};
        line-height: 3.875rem;
      }
      &.map1_container > .top_section > .top_section_left p {
        font-size: ${(props) => props?.textStyles?.body?.fontSize || '1.25rem'};
        font-weight: ${(props) => props?.textStyles?.body?.fontWeight || '400'};
        line-height: 1.75rem;
      }
      &.map1_container > .bottom_section iframe {
        height: 564px;
      }
    }
    @media screen and (max-width: 767px) {
      padding: 2rem 1rem;
      gap: 2.5rem;
      &.map1_container > .top_section {
        gap: 1rem;
        flex-direction: column;
      }
      &.map1_container > .top_section > .top_section_left h1 {
        font-size: 1.5rem;
        line-height: normal;
      }
      &.map1_container > .top_section > .top_section_left p {
        font-size: 0.875rem;
        line-height: normal;
      }
      &.map1_container > .top_section > .top_section_right {
        width: 100%;
      }
      &.map1_container > .top_section > .top_section_right button {
        width: 100%;
      }
      &.map1_container > .bottom_section iframe {
        height: 226px;
      }
    }
  }

  &.map4_container {
    display: flex;
    flex-direction: column;

    &.map4_container > .top_section {
      display: flex;
      flex: 0;
    }
    &.map4_container > .bottom_section {
      flex: 1;
    }
    &.map4_container > .top_section > .top_section_left {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      flex: 1;
    }
    &.map4_container > .top_section > .top_section_left h1 {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      width: 100%;
      margin: 0;
      color: ${(props) => props?.themeStyle?.heading?.color};
      font-family: ${(props) => props?.themeStyle?.heading?.fontFamily || 'Arial'};
      text-align: ${(props) => props?.themeStyle?.heading?.textAlign || 'left'};
      overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */
      overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */
    }
    &.map4_container > .top_section > .top_section_left p {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      width: 100%;
      font-style: normal;
      margin: 0;
      color: ${(props) => props?.themeStyle?.body?.color};
      text-align: ${(props) => props?.themeStyle?.body?.textAlign || 'left'};
      font-family: ${(props) => props?.themeStyle?.body?.fontFamily || 'Arial'};
      opacity: ${BODY_COLOR_OPACITY};
      overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */
      overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */
    }
    &.map4_container > .top_section > .top_section_right {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      align-self: center;
    }
    @media screen and (min-width: 768px) {
      padding: 4rem 0;
      gap: 2rem;
      &.map4_container > .top_section {
        gap: 4rem;
        flex-direction: row;
        padding: 0 4rem;
      }
      &.map4_container > .top_section > .top_section_left h1 {
        font-size: ${(props) => props?.textStyles?.heading?.fontSize || '3.25rem'};
        font-weight: ${(props) => props?.textStyles?.heading?.fontWeight || '500'};
        line-height: 3.875rem;
      }
      &.map4_container > .top_section > .top_section_left p {
        font-size: ${(props) => props?.textStyles?.body?.fontSize || '1.25rem'};
        font-weight: ${(props) => props?.textStyles?.body?.fontWeight || '400'};
        line-height: 1.75rem;
      }
      &.map4_container > .bottom_section iframe {
        height: 564px;
      }
    }
    @media screen and (max-width: 767px) {
      padding: 2rem 0;
      gap: 2.5rem;
      &.map4_container > .top_section {
        gap: 1rem;
        flex-direction: column;
        padding: 0 1rem;
      }
      &.map4_container > .top_section > .top_section_left h1 {
        font-size: 1.5rem;
        line-height: normal;
      }
      &.map4_container > .top_section > .top_section_left p {
        font-size: 0.875rem;
        line-height: normal;
      }
      &.map4_container > .top_section > .top_section_right {
        width: 100%;
      }
      &.map4_container > .top_section > .top_section_right button {
        width: 100%;
      }
      &.map4_container > .bottom_section iframe {
        height: 226px;
      }
    }
  }
`;
